import { MediaBreakpoints, spacing } from 'common/utils/helpers/theme.helpers';
import styled from 'styled-components';

export const FooterContainer = styled.div`
  max-width: 100%;
  border: none;
  background-color: ${({ theme }) => theme.customColors.F999};
  display: flex;
  overflow-x: hidden;
  margin-top: ${spacing(15)};
 
  ${MediaBreakpoints.down('md')} {
    display: block;
    padding-bottom: 0px;
  }

  ${MediaBreakpoints.down('sm')} {
    display: block;
    margin-left: 0;
    justify-content: center;
    padding-bottom: ${spacing(15)};
    padding-bottom: 0px;
  }
`;

export const FooterContainerItem = styled.div`
  color: ${({ theme }) => theme.palette.neutral.white};
  line-height: 2;
`;

export const FooterLogoContainer = styled.div`
  width: 184px;
  height: 33px;
  padding: ${spacing(22.5)} ${spacing(10.75)};
  ${MediaBreakpoints.down('md')} {
    padding: 0;
    margin-top: ${spacing(7)};
    margin-right: ${spacing(7)};
    margin-bottom: ${spacing(7)};
    margin-left: ${spacing(7.5)};
  }
  ${MediaBreakpoints.down('sm')} {
    padding: 0;
    margin-top: ${spacing(7)};
    margin-right: ${spacing(7)};
    margin-bottom: ${spacing(7)};
    margin-left: ${spacing(7.5)};
  }
`;

export const FooterInnerContainer = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.customColors.F996};
  left: 281px;
  right: 0px;
  bottom: 0px;
  margin-top: ${spacing(15.5)};
  ${MediaBreakpoints.down('md')} {
    padding: 0;
    margin-top: 0;
  }
  ${MediaBreakpoints.down('sm')} {
    margin-top: 0;
  }
`;
export const FooterInnerContainerContent = styled.div`
  display: flex;
  width: 100%;
  margin-left: 10%;
  margin-top: 3%;
  column-gap: 120px;

  ${MediaBreakpoints.down('md')} {
    display: block;
    :first-child {
      padding-top: 3%;
    }
  }
  ${MediaBreakpoints.down('sm')} {
    display: block;
    :first-child {
      padding-top: 3%;
    }
  }
`;
export const SocialMediaSection = styled.p`
  color: ${({ theme }) => theme.customColors.G100};
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
`;
export const SocialMediaItems = styled.p`
  color: ${({ theme }) => theme.palette.neutral.white};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: inline;
  vertical-align: text-top;
  margin-left: 10px;
  ${MediaBreakpoints.down('md')} {
    display: none;
  }
  ${MediaBreakpoints.down('sm')} {
    display: none;
  }
`;

export const AddressContent = styled.p`
  color: ${({ theme }) => theme.palette.neutral.white};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: inline;
  vertical-align: text-top;
`;
export const PrivacyAndPolicyContent = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: ${({ theme }) => theme.palette.neutral.white};
  margin-left: 10%;
  margin-top: 3%;
  margin-bottom: 4%;
`;
export const FooterContentBlocks = styled.div`
  // width: 22%;
  ${MediaBreakpoints.down('md')} {
    width: auto;
  }
  ${MediaBreakpoints.down('sm')} {
    width: auto;
  }
`;
export const FooterExtLink = styled.a`
  color: ${({ theme }) => theme.palette.neutral.white};
`;
export const MobileViewFlex = styled.div`
  ${MediaBreakpoints.down('md')} {
    display: flex;
  }
  ${MediaBreakpoints.down('sm')} {
    display: flex;
  }
`;
export const ContactDetailsItems = styled.p`
  color: ${({ theme }) => theme.palette.neutral.white};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: inline;
  vertical-align: text-top;
  margin-left: ${spacing(2.5)};
`;
